export { useStaticMenuContext, StaticMenuProvider, StaticMenuContext } from './static-menu';
